module.exports = {
  "title": {
    "paddingTop": 0,
    "paddingRight": "32",
    "paddingBottom": 0,
    "paddingLeft": "32"
  },
  "dof-collapse-item-content": {
    "backgroundColor": "#ffffff"
  },
  "title-box": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "height": "124",
    "alignItems": "center"
  },
  "bottom-line": {
    "borderBottomColor": "#dddddd",
    "borderBottomStyle": "solid",
    "borderBottomWidth": "2"
  },
  "title-text": {
    "height": "104",
    "lineHeight": "104",
    "fontSize": "32",
    "color": "#1e2e37"
  },
  "dof-header-arrow-box": {
    "height": "104",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "dof-header-arrow": {
    "width": "40",
    "height": "40",
    "marginLeft": "0",
    "right": "-8",
    "marginBottom": "12"
  },
  "dof-item-body": {
    "position": "relative",
    "overflow": "hidden",
    "backgroundColor": "#f9f9f9"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-7a9be4d0!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-collapse-item/index.vue
// module id = 519
// module chunks = 0 1